/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ManageRouteImport } from './routes/manage'
import { Route as LayoutsLayoutIdRouteImport } from './routes/layouts.$layoutId'
import { Route as VenuesIndexRouteImport } from './routes/venues.index'
import { Route as VenuesSlugRouteImport } from './routes/venues.$slug'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ManageRoute = ManageRouteImport.update({
  id: '/manage',
  path: '/manage',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutsLayoutIdRoute = LayoutsLayoutIdRouteImport.update({
  id: '/layouts/$layoutId',
  path: '/layouts/$layoutId',
  getParentRoute: () => rootRouteImport,
} as any)
const VenuesIndexRoute = VenuesIndexRouteImport.update({
  id: '/venues/',
  path: '/venues/',
  getParentRoute: () => rootRouteImport,
} as any)
const VenuesSlugRoute = VenuesSlugRouteImport.update({
  id: '/venues/$slug',
  path: '/venues/$slug',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/manage': typeof ManageRoute
  '/layouts/$layoutId': typeof LayoutsLayoutIdRoute
  '/venues/$slug': typeof VenuesSlugRoute
  '/venues/': typeof VenuesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/manage': typeof ManageRoute
  '/layouts/$layoutId': typeof LayoutsLayoutIdRoute
  '/venues/$slug': typeof VenuesSlugRoute
  '/venues': typeof VenuesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/manage': typeof ManageRoute
  '/layouts/$layoutId': typeof LayoutsLayoutIdRoute
  '/venues/$slug': typeof VenuesSlugRoute
  '/venues/': typeof VenuesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    '/' | '/manage' | '/layouts/$layoutId' | '/venues/$slug' | '/venues/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/manage' | '/layouts/$layoutId' | '/venues/$slug' | '/venues'
  id:
    | '__root__'
    | '/'
    | '/manage'
    | '/layouts/$layoutId'
    | '/venues/$slug'
    | '/venues/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ManageRoute: typeof ManageRoute
  LayoutsLayoutIdRoute: typeof LayoutsLayoutIdRoute
  VenuesSlugRoute: typeof VenuesSlugRoute
  VenuesIndexRoute: typeof VenuesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manage': {
      id: '/manage'
      path: '/manage'
      fullPath: '/manage'
      preLoaderRoute: typeof ManageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/layouts/$layoutId': {
      id: '/layouts/$layoutId'
      path: '/layouts/$layoutId'
      fullPath: '/layouts/$layoutId'
      preLoaderRoute: typeof LayoutsLayoutIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/venues/': {
      id: '/venues/'
      path: '/venues'
      fullPath: '/venues/'
      preLoaderRoute: typeof VenuesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/venues/$slug': {
      id: '/venues/$slug'
      path: '/venues/$slug'
      fullPath: '/venues/$slug'
      preLoaderRoute: typeof VenuesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ManageRoute: ManageRoute,
  LayoutsLayoutIdRoute: LayoutsLayoutIdRoute,
  VenuesSlugRoute: VenuesSlugRoute,
  VenuesIndexRoute: VenuesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
